import React, { useMemo, useState } from "react";
import { NavLink } from 'react-router-dom';
import { loginUser } from '../features/auth/login/api/loginApi';
import WelcomeAgentsModal from '../features/navigation/ui/WelcomeAgentsModal';
import { persistLoggedUserSession, redirectToAppHome } from '../shared/services/authSessionService';
import { getCurrentLanguageKey, getLanguageSection } from '../shared/services/languageService';

function Login() {
  const [login, setLogin] = useState({
    username: '',
    password: '',
    marivalrewards: -1
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showResetNotice, setShowResetNotice] = useState(false);

  const language = useMemo(() => getLanguageSection('login'), []);
  const currentLanguage = getCurrentLanguageKey();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const [, field] = name.split('.');

    setErrorMessage('');
    setShowResetNotice(false);
    setLogin((currentLogin) => ({
      ...currentLogin,
      [field]: value
    }));
  };

  const handleLogin = async () => {
    setErrorMessage('');
    setShowResetNotice(false);
    setIsSubmitting(true);

    try {
      const response = await loginUser(login);
      const data = response.data || response;

      persistLoggedUserSession(data);
      redirectToAppHome();
    } catch (error) {
      const nextErrorMessage =
        (error.payload && error.payload.errorMessage) ||
        error.message ||
        'Unable to login';

      setShowResetNotice(error?.payload?.result === false);
      setErrorMessage(
        nextErrorMessage
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div id="login-content" className="mr-ui flex min-h-[calc(100vh-180px)] items-center justify-center bg-[#f3f5fb] px-4 py-10 md:px-8">
      <WelcomeAgentsModal />

      <section className="w-full max-w-[430px] rounded-lg border border-slate-200 bg-white p-6 shadow-[0_4px_18px_rgba(17,24,63,0.10)] md:p-8">
        <div className="mb-7 text-center">
         
          <h1 className="m-0 text-3xl font-black leading-tight text-[#071a4a] md:text-4xl">
            {language.welcome}
          </h1>
          <p className="mb-0 mt-3 text-base leading-7 text-[#3c4863]">
            {language.text1}
          </p>
        </div>

        {showResetNotice ? (
          <div className="mb-5 rounded-xl border border-orange-200 bg-orange-50 p-4 text-orange-950">
            <div className="mb-1 text-sm font-black text-orange-900">
              {language.updateNoticeTitle}
            </div>
            <p className="mb-2 text-sm leading-6">
              {language.updateNoticeText}
            </p>
            <p className="mb-0 text-sm leading-6">
              {language.updateNoticeAction}
            </p>
          </div>
        ) : null}

        <div className="mb-5">
          <label htmlFor="floatingInput" className="mb-2 block text-sm font-black text-[#071a4a]">
            {language.email}
          </label>
          <input
            type="email"
            className="Email mr-login-input h-12 w-full rounded-lg border border-[#d6e0ee] bg-[#eaf2ff] px-3.5 py-2.5 text-sm text-[#071a4a] shadow-none outline-none transition focus:border-[#4f9ac4] focus:bg-white focus:ring-2 focus:ring-[#4f9ac4]/20"
            id="floatingInput"
            placeholder="email"
            value={login.username}
            onChange={handleInputChange}
            name="login.username"
          />
        </div>

        <div className="mb-6">
          <label htmlFor="floatingPassword" className="mb-2 block text-sm font-black text-[#071a4a]">
            {language.password}
          </label>
          <input
            type="password"
            className="mr-login-input h-12 w-full rounded-lg border border-[#d6e0ee] bg-[#eaf2ff] px-3.5 py-2.5 text-sm text-[#071a4a] shadow-none outline-none transition focus:border-[#4f9ac4] focus:bg-white focus:ring-2 focus:ring-[#4f9ac4]/20"
            id="floatingPassword"
            placeholder="password"
            value={login.password}
            onChange={handleInputChange}
            name="login.password"
          />
        </div>

        <button
          className="inline-flex h-12 w-full items-center justify-center rounded-md border-0 bg-[#4f9ac4] text-sm font-black text-white shadow-[0_12px_24px_rgba(79,154,196,0.26)] transition hover:bg-[#438eb8] disabled:cursor-wait disabled:opacity-70"
          onClick={handleLogin}
          disabled={isSubmitting}
        >
          {isSubmitting ? '...' : language.loginbtn}
        </button>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-3 text-sm">
          <NavLink
            className="font-black text-[#ff5b12] hover:text-[#c94c04]"
            to={`/agentregister?lang=${currentLanguage}`}
          >
            {language.link1}
          </NavLink>

          <span className="text-slate-300">|</span>

          <NavLink
            className="font-black text-[#ff5b12] hover:text-[#c94c04]"
            to={`/forgotpassword?lang=${currentLanguage}`}
          >
            {language.link2}
          </NavLink>
        </div>

        <div
          className="mt-5 rounded-xl bg-red-50 px-4 py-3 text-sm leading-6 text-red-700"
          style={{ display: errorMessage ? 'block' : 'none' }}
        >
          {errorMessage}
        </div>
      </section>
    </div>
  );
}

export default Login;
